<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-aprovacao-compra-filters ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      label="Busque por código ou comprador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import AprovacaoCompraFilters from '@/modules/aprovacao-compra/AprovacaoCompraFilters.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'PENDENTES',
          description: 'Pendentes',
          value: 'PENDENTE',
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: 'APROVADO',
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: 'RECUSADO',
        },
      ],
    };
  },
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
  },
  computed: {
    ...mapGetters('listagemAprovacaoCompra', ['hasCustomFilters']),
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
    selectedStatus: {
      get() {
        return this.$store.getters['listagemAprovacaoCompra/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemAprovacaoCompra/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemAprovacaoCompra/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemAprovacaoCompra/searchText', searchText);
      },
    },
  },
  created() {
    if (!this.selectedStatus) {
      this.selectedStatus = this.statusOptions.find(option => option.id === 'PENDENTES');
    }
  },
  components: {
    pxAprovacaoCompraFilters: AprovacaoCompraFilters,
  },
};
</script>
